import React from 'react';
import styled from 'styled-components';
import { InnerSection, Section } from '../../styles/section/section';
import Chat from '../search/components/no-results/chat';
import Support from '../search/components/no-results/support';

const NotFoundPageInnerSection = styled(InnerSection)`
  align-items: center;
  justify-content: center;
  text-align: center;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
`;

export const Error = () => {
  return (
    <Section>
      <NotFoundPageInnerSection>
        <h3>
          Sorry, we don't have an answer for that. Ask your question in chat and we can help you
          out!
        </h3>

        <br />

        <Wrapper>
          <Chat />
          <Support />
        </Wrapper>
      </NotFoundPageInnerSection>
    </Section>
  );
};
